import React from "react";
import "./shared.css";

export default function SectionHeader({ title, subtitle, actions }) {
  return (
    <div className="section-header-shared">
      <div className="section-header-content">
        <h2 className="section-header-title">{title}</h2>
        {subtitle && <p className="section-header-subtitle">{subtitle}</p>}
      </div>
      {actions && <div className="section-header-actions">{actions}</div>}
    </div>
  );
}
